// src/auth/useAuth.ts
import { useCookies } from 'react-cookie';

type JwtPayload = {
  exp?: number;
  email?: string;
};

export const useAuth = () => {
  const [cookies] = useCookies(['idToken']);

  let payload: JwtPayload | null = null;

  const token = cookies.idToken;
  if (token) {
    try {
      payload = JSON.parse(atob(token.split('.')[1])) as JwtPayload;
    } catch {
      payload = null;
    }
  }

  const isAuthenticated = !!payload?.exp && payload.exp * 1000 > Date.now();

  const email = payload?.email ?? null;

  return {
    isAuthenticated,
    email,
  };
};
